import React, { useState } from 'react';
import api from '../services/api';
import { refreshUser } from '../services/auth';
import toast from '../services/toast';
import Icon from '../components/Icon';
import './Cupons.css';

export default function Cupons() {
  const [codigo, setCodigo] = useState('');
  const [validando, setValidando] = useState(false);
  const [validado, setValidado] = useState(null);
  const [erro, setErro] = useState('');
  const [resgatando, setResgatando] = useState(false);
  const [resgatado, setResgatado] = useState(null);

  async function validar(e) {
    e.preventDefault();
    if (!codigo.trim()) return;
    setErro('');
    setValidado(null);
    setValidando(true);
    try {
      const data = await api.get(`/cupons/validar/${encodeURIComponent(codigo.trim())}`);
      setValidado(data);
    } catch (err) {
      setErro(err.message);
    } finally {
      setValidando(false);
    }
  }

  async function resgatar() {
    setResgatando(true);
    try {
      const data = await api.post('/cupons/resgatar', { codigo: validado.codigo });
      setResgatado(data);
      toast.success('Cupom resgatado com sucesso!');
      await refreshUser();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setResgatando(false);
    }
  }

  function novoCupom() {
    setCodigo('');
    setValidado(null);
    setErro('');
    setResgatado(null);
  }

  return (
    <div className="cupons-page">
      <h1 className="page-title"><Icon name="gift" size={20} /> Cupons</h1>
      <p className="cupons-sub">Tem um cupom promocional? Resgate aqui e ganhe benefícios exclusivos na sua conta.</p>

      {resgatado ? (
        <div className="card cupom-resultado">
          <div className="cupom-resultado__icone"><Icon name="check" size={28} /></div>
          <h3>Cupom resgatado com sucesso!</h3>
          <p>Você recebeu:</p>
          <div className="cupom-resultado__beneficios">
            <span>⭐ +{resgatado.pontos_bonus} pontos</span>
            <span>👑 {resgatado.dias_premium} dias Premium</span>
          </div>
          <button className="btn btn-secondary btn-block" style={{ marginTop: 16 }} onClick={novoCupom}>
            Resgatar outro cupom
          </button>
        </div>
      ) : (
        <div className="card">
          <form onSubmit={validar}>
            <div className="form-group">
              <label>Código do cupom</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  value={codigo}
                  onChange={e => { setCodigo(e.target.value.toUpperCase()); setValidado(null); setErro(''); }}
                  placeholder="Digite seu cupom"
                  style={{ flex: 1 }}
                />
                <button type="submit" className="btn btn-secondary" disabled={validando || !codigo.trim()}>
                  {validando ? 'Validando...' : 'Validar'}
                </button>
              </div>
            </div>
          </form>

          {erro && <div className="alert alert-error">{erro}</div>}

          {validado && (
            <div className="cupom-box" style={{ marginTop: 4 }}>
              <label>🎉 Cupom {validado.codigo} válido!</label>
              {validado.descricao && <p style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 10 }}>{validado.descricao}</p>}
              <div className="cupom-resultado__beneficios" style={{ marginBottom: 12 }}>
                <span>⭐ +{validado.pontos_bonus} pontos</span>
                <span>👑 {validado.dias_premium} dias Premium</span>
              </div>
              <button className="btn btn-primary btn-block" onClick={resgatar} disabled={resgatando}>
                {resgatando ? 'Resgatando...' : 'Resgatar benefícios'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
